import { Card, CardContent } from '@/components/ui/card';
import { Check, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface ComparisonTableProps {
  title?: string;
  rows: {
    feature: string;
    manual: boolean;
    spreadsheet: boolean;
    rentalManager: boolean;
  }[];
}

export const ComparisonTable = ({ 
  title = "Why Rental Manager vs Manual Methods",
  rows 
}: ComparisonTableProps) => {
  const { t } = useTranslation();
  
  return (
    <section className="py-16 bg-gradient-to-b from-background to-muted/30">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl font-bold mb-12 text-center">{title}</h2>
        
        <div className="max-w-5xl mx-auto overflow-x-auto">
          <Card>
            <CardContent className="p-0">
              <table className="w-full">
                <thead className="bg-muted/50">
                  <tr>
                    <th className="text-left p-4 font-semibold">{t('cleanerTool.comparison.headers.feature')}</th>
                    <th className="text-center p-4 font-semibold text-muted-foreground">{t('cleanerTool.comparison.headers.manual')}</th>
                    <th className="text-center p-4 font-semibold text-muted-foreground">{t('cleanerTool.comparison.headers.spreadsheet')}</th>
                    <th className="text-center p-4 font-semibold text-primary">{t('cleanerTool.comparison.headers.rentalManager')}</th>
                  </tr>
                </thead>
                <tbody>
                  {rows.map((row, index) => (
                    <tr key={index} className="border-t border-border">
                      <td className="p-4 font-medium">{row.feature}</td>
                      <td className="text-center p-4">
                        {row.manual ? (
                          <Check className="w-5 h-5 text-muted-foreground mx-auto" />
                        ) : (
                          <X className="w-5 h-5 text-destructive mx-auto" />
                        )}
                      </td>
                      <td className="text-center p-4">
                        {row.spreadsheet ? (
                          <Check className="w-5 h-5 text-muted-foreground mx-auto" />
                        ) : (
                          <X className="w-5 h-5 text-destructive mx-auto" />
                        )}
                      </td>
                      <td className="text-center p-4 bg-primary/5">
                        {row.rentalManager ? (
                          <Check className="w-5 h-5 text-primary mx-auto" />
                        ) : (
                          <X className="w-5 h-5 text-destructive mx-auto" />
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};
